module.exports = __webpack_public_path__ + "cert_4.jpg?78b445c8df99499cbd5c8a7b59bf25bf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cert_4.jpg
// module id = 34
// module chunks = 0